import { GalaxyApi } from "@/api";
import { rethrowSimple } from "@/utils/simple-error";
export async function updateTags(itemId, itemClass, itemTags) {
    const { error } = await GalaxyApi().PUT("/api/tags", {
        body: {
            item_id: itemId,
            item_class: itemClass,
            item_tags: itemTags,
        },
    });
    if (error) {
        rethrowSimple(error);
    }
}
